import { Tooltip, Space, Button, Badge } from "antd";
// import { Image } from "antd";
// import { PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  EditOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { BACKEND_URL_MAIN, formatCommaNumber } from "../../../utils/util";
import {
  EditableRow,
  EditableCell,
} from "../../../components/table/TableEditAble";

import { TagItemTypes } from "../../../components/badge-and-tag/ERP";

import { docLinkRender } from "../../../components/table/DocLink";
// import dayjs from 'dayjs';
/** export component for edit table */
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

export const accessColumn = ({ handleEdit, handleDelete, handleView }) => [
  {
    key: "id",
    dataIndex: "id",
    align: "left",
    hidden: true,
  },
  {
    title: "PG Code",
    dataIndex: "pg_code",
    key: "pg_code",
    sorter: (a, b) => (a?.pg_code || "").localeCompare(b?.pg_code || ""),
    width: 140,
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดูข้อมูลสินค้า"),
  },
  {
    title: "PG Name (TH)",
    dataIndex: "pg_name",
    key: "pg_name",
    width: "25%",
    sorter: (a, b) => (a?.pg_name || "").localeCompare(b?.pg_name || ""),
    ellipsis: { showTitle: false },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),
  },
  {
    title: "Customer PG Name",
    dataIndex: "pg_stname_cus",
    key: "pg_stname_cus",
    width: "25%",
    sorter: (a, b) =>
      (a?.pg_stname_cus || "").localeCompare(b?.pg_stname_cus || ""),
    ellipsis: { showTitle: false },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    sorter: (a, b) => (a?.code || "").localeCompare(b?.code || ""),
    width: 140,
  },
  {
    title: "สถานะ",
    dataIndex: "active_status",
    key: "active_status",
    width: "10%",
    sorter: (a, b) =>
      (a?.active_status || "").localeCompare(b?.active_status || ""),
    render: (data) => (
      <div>
        {data === "เปิดการใช้งาน" ? (
          <Badge status="success" text="เปิดการใช้งาน" />
        ) : (
          <Badge status="error" text="ปิดการใช้การ" />
        )}
      </div>
    ),
  },
  // {
  //   title: "ราคา",
  //   dataIndex: "price",
  //   key: "price",
  //   className: "!pe-4",
  //   align:'right',
  //   sorter: (a, b) => (a?.price || "").localeCompare(b?.price || ""),
  //   render:(v)=>formatMoney( Number(v || 0))
  // },
  {
    title: "Action",
    key: "operation",
    width: "60px",
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Badge size="small" offset={[0, 1]}>
          <Button
            icon={<ExclamationCircleOutlined />}
            className="bn-success-outline"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => handleView(record)}
            size="small"
          />
        </Badge>
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
      </Space>
    ),
  },
];

export const listcolumn = ({handleDelete}) => {
  return [
    {
      title: "No.",
      key: "seq",
      dataIndex: "seq",
      align: "left",
      width: 80,
      render: (_, record, idx) => <span key={record?.code}>{idx + 1}</span>,
    },
    {
      title: "Code",
      align: "left",
      width: 300,
      key: "mat_code",
      dataIndex: "mat_code",
    },
    {
      title: "ชื่อวัตุดิบ",
      key: "mat_name",
      dataIndex: "mat_name",
    },
    {
      title: "ประเภทวัตถุดิบ",
      key: "typename",
      dataIndex: "typename",
      width: 180,
      render: (data) => <TagItemTypes data={data} />,
    },
    {
      title: "คำอธิบาย",
      key: "description",
      dataIndex: "description",      
      width: 200,
      editable: true,
      required: false,
      type: "input",      
    },
    {
      title: "Action",
      key: "operation",
      width: "60px",
      fixed: "right",
      render: (text, record) => (
        <Space>
          <Button
            icon={<DeleteOutlined />}
            // className="bn-primary-outline"
            danger
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => handleDelete(record)}
            size="small"
          />
        </Space>
      ),
    },
  ].filter((item) => !item.hidden);
};

export const listcolumnView = () => {
  return [
    {
      title: "No.",
      key: "seq",
      dataIndex: "seq",
      align: "left",
      width: 80,
      render: (_, record, idx) => <span key={record?.code}>{idx + 1}</span>,
    },
    {
      title: "Code",
      align: "left",
      width: 300,
      key: "mat_code",
      dataIndex: "mat_code",
    },
    {
      title: "ชื่อวัตุดิบ",
      key: "mat_name",
      dataIndex: "mat_name",
    },
    {
      title: "ประเภทวัตถุดิบ",
      key: "typename",
      dataIndex: "typename",
      width: 180,
      render: (data) => <TagItemTypes data={data} />,
    },
    {
      title: "คำอธิบาย",
      key: "description",
      dataIndex: "description",      
      width: 200,    
    },
  ].filter((item) => !item.hidden);
};

export const listcolumnsEditable = (handleSave,{ handleDelete }) => {
  const col = listcolumn({ handleDelete });
  return col.map((c) => {
    if (!c.editable) return c;
    return {
      ...c,
      onCell: (record) => ({
        record,
        editable: c.editable,
        dataIndex: c.dataIndex,
        title: c.title,
        handleSave, 
        fieldType: !!c.textArea,
        required: !!c.required,
        type: c.type || "input",
        autocompleteOption: c.autocompleteOption,
      }),
    };
  });
};

export const PG = {
  id: null,
  pg_code: null,
  pg_name: null,
  pg_nameEN: null,
  pg_type: null,
  pg_stname_cus: null,
  code: null,
  unit: null,
  weight_nw: 0,
  weight_gw: 0,
  feature: null,
  remarks: null,
  active_status: null,
};
